import { useState } from "react";
import axios from "axios";
import { Loader2, ArrowRight } from "lucide-react";
import { Input } from "../ui/input";
import { Label } from "../ui/label";

const API = `${process.env.REACT_APP_BACKEND_URL}/api`;

const errorText = (detail) => {
  if (typeof detail === "string") return detail;
  if (Array.isArray(detail)) return detail.map((e) => e?.msg).filter(Boolean).join(" ");
  return "Unable to sign in. Please try again.";
};

export default function AdminLogin({ onSuccess }) {
  const [form, setForm] = useState({ email: "", password: "" });
  const [error, setError] = useState("");
  const [busy, setBusy] = useState(false);

  const submit = async (e) => {
    e.preventDefault();
    setBusy(true);
    setError("");
    try {
      const { data } = await axios.post(`${API}/auth/login`, form, { withCredentials: true });
      onSuccess(data);
    } catch (err) {
      setError(errorText(err.response?.data?.detail));
    } finally {
      setBusy(false);
    }
  };

  return (
    <div data-testid="admin-login" className="min-h-screen grid place-items-center bg-navy px-6">
      <form onSubmit={submit} className="w-full max-w-md bg-cream border border-navy/10 rounded-2xl p-10 shadow-2xl">
        <img src="/logo.png" alt="" width="56" height="56" className="w-14 h-14 rounded-full mb-6" />
        <p className="text-xs uppercase tracking-[0.3em] font-semibold text-navy/60">The Formulation House</p>
        <h1 className="font-display text-navy text-3xl mt-2 mb-8">Leads admin</h1>
        <div className="space-y-5">
          <div className="space-y-1.5">
            <Label htmlFor="admin-email" className="text-navy">Email</Label>
            <Input data-testid="admin-email-input" id="admin-email" type="email" autoComplete="username" value={form.email}
              onChange={(e) => setForm((f) => ({ ...f, email: e.target.value }))} className="bg-white border-navy/15" required />
          </div>
          <div className="space-y-1.5">
            <Label htmlFor="admin-password" className="text-navy">Password</Label>
            <Input data-testid="admin-password-input" id="admin-password" type="password" autoComplete="current-password" value={form.password}
              onChange={(e) => setForm((f) => ({ ...f, password: e.target.value }))} className="bg-white border-navy/15" required />
          </div>
          {error && <p data-testid="admin-login-error" className="text-sm text-red-700">{error}</p>}
          <button data-testid="admin-login-submit" type="submit" disabled={busy}
            className="group w-full inline-flex items-center justify-center gap-3 rounded-full bg-navy text-ivory px-8 py-3.5 text-sm font-semibold tracking-wide transition-transform duration-300 hover:-translate-y-0.5 disabled:opacity-60">
            {busy ? <Loader2 size={16} className="animate-spin" /> : <>Sign in <ArrowRight size={16} strokeWidth={1.5} className="transition-transform duration-300 group-hover:translate-x-1" /></>}
          </button>
        </div>
      </form>
    </div>
  );
}
